import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { AppUtilityService } from 'src/app/app-utility.service';
//import { ClientDetailsService } from '../rest-services/client-details.service';
import { MdbModalRef, MdbSelectModule } from 'src/lib/mdb5-adapted/public-api';

import { LMSConstantsService } from '@lmsConstants';
import { NextOfKinModel } from '@lmsModels';

//import { NextOfKinV2 } from "./nok-editor/nok.model";
import { LmsModalFrameComponent, NumbersOnlyDirective, LMS_NoSpecialsDirective } from '@lmsSharedUI';

// enum CheckBoxType {
//   APPLY_FOR_JOB,
//   MODIFY_A_JOB,
//   NONE,
// }

const ADDRESS_TYPE_NEXTOFKIN = 'NEXTOFKIN';
const CLIENT_TYPE_SASSA = 'SASSA';
const PHONE_NUMBER_PATTERN = new RegExp('^[0-9]{10}$');
const AREA_CODE_PATTERN = '^[0-9]{4}$';
const NO_SPECIAL_CHARS_PATTERN = /^[a-zA-Z0-9\s]*$/;

@Component({
  selector: 'app-next-of-kin',
  templateUrl: './next-of-kin.component.html',
  styleUrls: ['./next-of-kin.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush, // Use OnPush strategy
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdbSelectModule,
    LmsModalFrameComponent,
    NumbersOnlyDirective,
    LMS_NoSpecialsDirective
  ],
})
export class NextOfKinComponent implements OnInit {
  nextOfKin: any | null;
  labelPosition: 'before' | 'after' = 'after';

  clientDetails: any;
  nextOfKinForm: FormGroup;
  nextOfKin2Form: FormGroup;
  nextOfKinModel = new NextOfKinModel();
  private _hasNextOfKin?: boolean;
  private _hasNextOfKin2?: boolean;
  submitted?: boolean = false;
  isValidForm?: boolean = false;
  addresses?: any;
  displayWidth = 390;
  lmsUserProfile: any;
  isReadOnly = false;
  clientStatus: string | '';

  isSassaClient?: boolean = false;

  newNOK: any;
  newquoteModel: any;
  newquoteAssress: any;
  newreadonly: any;
  lstProvince = this.lmsConstantService.getLMSConstant('PROVINCES');
  lstRelationship= this.lmsConstantService.getLMSConstant('RELATIONSHIP');
  constructor(
    public fb: FormBuilder,
    public global_utility: AppUtilityService,
    public dialogRef: MdbModalRef<NextOfKinComponent>,
    private cdr: ChangeDetectorRef,
    private lmsConstantService: LMSConstantsService
  ) {}

  get hasNextOfKin() {
    return this._hasNextOfKin || false;
  }

  get hasNextOfKin2() {
    return this._hasNextOfKin2 || false;
  }

  removeSpaces(event: any): void {
    if (event.target.value) {
      event.target.value = event.target.value.replace(/\s/g, '');
    }
  }

  public getNumberPattern = () => {
    this.isSassaClient ? PHONE_NUMBER_PATTERN : '^[0-9]{10}$';
  }

  private createNextOfKinForm(prefix: string): FormGroup {
    const addline1 = (prefix=='1')?'addressLine1':'line1';
    const addline2 = (prefix=='1')?'addressLine2':'line2';

    return this.fb.group({
      [`name${prefix}`]: ['', [Validators.required, Validators.pattern(NO_SPECIAL_CHARS_PATTERN)]],
      [`surname${prefix}`]: ['', [Validators.required, Validators.pattern(NO_SPECIAL_CHARS_PATTERN)]],
      [`${addline1}`]: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9\s,.-]*$/)]],
      [`${addline2}`]: ['', [Validators.pattern(/^[a-zA-Z0-9\s,.-]*$/)]],
      [`suburb${prefix}`]: ['', [Validators.required, Validators.pattern(NO_SPECIAL_CHARS_PATTERN)]],
      [`town${prefix}`]: ['', [Validators.required, Validators.pattern(NO_SPECIAL_CHARS_PATTERN)]],
      [`areaCode${prefix}`]: [
        '',
        [Validators.required, Validators.pattern(AREA_CODE_PATTERN)],
      ],
      [`email${prefix}`]: ['', [Validators.email]],
      [`contactNo${prefix}`]: [
        '',
        [Validators.required, Validators.pattern(PHONE_NUMBER_PATTERN)],
      ],
      [`relationship${prefix}`]: [[], [Validators.required]],
      [`province${prefix}`]: [[], [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.nextOfKinForm = this.createNextOfKinForm('1');
    this.nextOfKin2Form = this.createNextOfKinForm('2');
    this._hasNextOfKin = false;

    // Defensive: some shallow unit tests don't provide `clientDetails`.
    this.checkClientType();
    this.clientStatus = this.clientDetails?.clientStatus || '';
    this.validateNextOfKin();
  }

  checkClientType() {
    if (this.clientDetails?.clientType === CLIENT_TYPE_SASSA) {
      this.isSassaClient = true;
    }
    this.nextOfKinModel.onlyOneNextOfKin = false;
  }

  onSaveSubmit(): void {
    this.submitted = true;
    this.isValidForm = true;

    if (this.nextOfKinForm?.invalid || this.nextOfKin2Form?.invalid) {
      this.isValidForm = false;
      //let invControls = this.findInvalidControls();
      this.global_utility.error(
        `Please ensure that all the information needed on this page is entered`,
        'Information required',
      );
      return;
    }

    if (this.isSassaClient && this.nextOfKinModel.onlyOneNextOfKin) {
      if (this.nextOfKin2Form?.invalid) {
        this.isValidForm = false;
        this.global_utility.warning(
          `SASSA clients must provide details for two Next of Kin`,
          'Information required',
        );
        return;
      }
    }

    if (this.isValidForm) {
      // this.saveNextOfKin();
      // this.updateAddress();
      this.nextOfKinModel = {
        ...this.nextOfKinModel,
        ...Object.fromEntries(Object.entries(this.nextOfKinForm?.value || {}).map(([key, value]) => [key, value ?? ''])),
        ...Object.fromEntries(Object.entries(this.nextOfKin2Form?.value || {}).map(([key, value]) => [key, value ?? '']))
      }
      this.dialogRef.close(this.nextOfKinModel);
    }
  }

  validateNextOfKin(): void {
    this.isValidForm = true;
    if (this.nextOfKin) {
      const nokSize = this.nextOfKin.length;
      this._hasNextOfKin2 = nokSize > 1;

      this.populateNextOfKinDetails(this.nextOfKin[0], this.addresses);

      if (this.nextOfKinModel.addressLine1 == null || this.nextOfKinModel.addressLine1 == '' ||
          this.nextOfKinModel.province1 == null || this.nextOfKinModel.province1 == ''||
          this.nextOfKinModel.areaCode1 ==  null || this.nextOfKinModel.areaCode1 == '') {
        this.isValidForm = false;
      }

      if (this._hasNextOfKin2) {
        this.populateNextOfKinDetails(this.nextOfKin[1], this.addresses, true);

        if (this.nextOfKinModel.line1 == null || this.nextOfKinModel.line1 == '' ||
          this.nextOfKinModel.province2 == null|| this.nextOfKinModel.province2 == '' ||
          this.nextOfKinModel.areaCode2 == null ||this.nextOfKinModel.areaCode2 == '') {
        this.isValidForm = false;
      }
      }
    }
  }

  private populateNextOfKinDetails(nok: any, addresses: any[], isSecond: boolean = false): void {
    const prefix = isSecond ? '2' : '1';
    if (nok) {
      this[`_hasNextOfKin${isSecond ? '2' : ''}`] = true;

      this.nextOfKinModel[`name${prefix}`] = nok.firstName;
      this.nextOfKinModel[`relationship${prefix}`] = nok.relationship;
      this.nextOfKinModel[`surname${prefix}`] = nok.lastName;
      this.nextOfKinModel[`email${prefix}`] = nok.email;
      this.nextOfKinModel[`contactNo${prefix}`] = nok.contactNo1;
      this.nextOfKinModel[`address${prefix}id`] = nok.address1id;

      const address = addresses.find(
        (addr) => addr.addressType === ADDRESS_TYPE_NEXTOFKIN && addr.id === nok.homeAddressId
      );

      const addline1 = (!isSecond)?'addressLine1':'line1';
      const addline2 = (!isSecond)?'addressLine2':'line2';
      if (address) {
        this.nextOfKinModel[`${addline1}`] = address.line1;
        this.nextOfKinModel[`${addline2}`] = address.line2;

        this.nextOfKinModel[`suburb${prefix}`] = address.suburb;
        this.nextOfKinModel[`province${prefix}`] = address.province;
        this.nextOfKinModel[`town${prefix}`] = address.town;
        this.nextOfKinModel[`areaCode${prefix}`] = address.code;
      }
    }

  }

  onReset() {
    this.submitted = false;
    this.nextOfKinForm?.reset();
  }

  close() {
    this.dialogRef.close();
  }

  editNextOfKin() {
    this.nextOfKinForm.patchValue(this.nextOfKinModel,{onlySelf: false});
    this.nextOfKin2Form.patchValue(this.nextOfKinModel,{onlySelf: false});

    this.nextOfKin2Form?.get('relationship2')?.setValue(this.nextOfKinModel.relationship2);
    this.nextOfKinForm?.get('relationship1')?.setValue(this.nextOfKinModel.relationship1);

    this._hasNextOfKin = false;
    setTimeout(() => {
      this.relationship2.reset();
      this.nextOfKin2Form?.get('province2')?.reset();

      if(this.nextOfKinModel.relationship2){
        this.nextOfKin2Form?.get('relationship2')?.setValue(this.nextOfKinModel.relationship2);
      }
      if(this.nextOfKinModel.relationship1){
        this.nextOfKinForm?.get('relationship1')?.setValue(this.nextOfKinModel.relationship1);
      }
      if(this.nextOfKinModel.province2){
        this.nextOfKin2Form?.get('province2')?.setValue(this.nextOfKinModel.province2);
      }
      if(this.nextOfKinModel.province1){
        this.nextOfKinForm?.get('province1')?.setValue(this.nextOfKinModel.province1);
      }

       // Explicitly trigger change detection after updating values
      this.cdr.markForCheck();
    }, 50);
  }

  get validateNok() {
    const ctrl = this.nextOfKinForm?.controls;
    return ctrl;
  }

  get validateNok2() {
    return this.nextOfKin2Form?.controls;
  }

  get contactNo1() {
    return (
      this.nextOfKinModel.contactNo1 &&
      this.nextOfKinModel.contactNo1.length == 10
    );
  }

  get contactNo2() {
    if (this.nextOfKinModel.onlyOneNextOfKin) {
      return true;
    }

    return (
      this.nextOfKinModel.contactNo2 &&
      this.nextOfKinModel.contactNo2.length == 10
    );
  }

  get relationship2() {
    return this.nextOfKin2Form?.controls?.relationship2;
  }

  confirmNextOfKinDetails() {
    if (this.nextOfKinModel.province1 == '' ||
    this.nextOfKinModel.areaCode1  == '' ||
    this.nextOfKinModel.province2  == '' ||
    this.nextOfKinModel.areaCode2  == '')
    {
      this.isValidForm = false;
    }

    if(!this.isValidForm) {
      this.global_utility.warning(
        `Please ensure that all the information needed on this page is entered`,
        'Information required!!!',
      );
      return;
    }

    this.nextOfKinModel.isConfirmedNokDetails = true;
    this.nextOfKinModel.quoteId = this.clientDetails?.quoteId;
    this.dialogRef.close(this.nextOfKinModel);
  }
}
